import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SessionPaymentTransaction, Tenant } from '../../models';
import { CustomerPayment } from '../../models/payment-document.model';
import {
  ModifiedSessionDocumentInfo,
  SessionDocumentInfo,
} from '../../models/session/session-document-info.model';
import { AutopayEnrollmentBannerVariant } from '../autopay-enrollment-banner/autopay-enrollment-banner.component';

@Component({
  selector: 'payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.scss'],
})
export class PaymentSummaryComponent {
  @Input() customerPayment: CustomerPayment;
  @Input() tenantDetails: Tenant;
  @Input() documents: SessionDocumentInfo[];
  @Input() modifiedDocuments: ModifiedSessionDocumentInfo[];
  @Input() isReadOnly = true;
  @Input() transactions: SessionPaymentTransaction[];
  @Input() hasMultipleTransactions: boolean;
  @Input() transactionBuyerAccounts: string[];
  @Input() transactionsTotal: number;
  @Input() transactionsSubTotal: number;
  @Input() transactionsCreditTotal: number;
  @Input() transactionsAppliedDiscountTotal: number;
  @Input() isDiscountAmountVisible: boolean;
  @Input() isSurchargeFeeVisible: boolean;
  @Input() isSurchargeFeePercentageVisible: boolean;
  @Input() transactionsSurchargeTotal: number;
  @Input() surchargePercentage: number;
  @Input() isAutopaySupported: boolean;
  @Input() isAutopayEnabled: boolean;
  @Input() showAutopayEnrollmentBanner: boolean;
  @Input() autopayBannerVariant: AutopayEnrollmentBannerVariant = 'domestic';
  @Output() enrollInAutopayClicked = new EventEmitter<void>();

  excludedTransactionTableCols = ['transactionNumber'];
  excludedDocumentTableCols = ['dueDate', 'amountPaid'];
}
